module.exports = __webpack_public_path__ + "static/media/close.d231ee52.svg";